import auth from './auth'
import withClientId from './with-client-id'

export {
  auth,
  withClientId
}



// WEBPACK FOOTER //
// ./src/hocs/index.js